import React from 'react';
import ExternalRedirect from './ExternalRedirect';

const App = () => {
  return (
    <div>
      <ExternalRedirect to="https://linktr.ee/cardanistas" />
    </div>
  );
};

export default App;
